module.exports = __webpack_public_path__ + "static/laboheme4s-45d5367db3aef6896bc848ce4e93506d.jpg";